import { USER_TYPES } from '../../../utils/constants';
import { MFA_FACTOR_IDS } from '../constants';
import { isSMSMFAMandatory } from './userNeedsSMSMFASetup';
import { isTOTPMFAMandatory } from './userNeedsTOTPMFASetup';

/**
 * Determines if a MFA method is mandatory for a user.
 * Ordered by priority of MFA methods.
 *
 * For patients, neither individual method is mandatory - they just need at least one.
 * This affects the "Remove" vs "Reconfigure" button text in account settings.
 *
 * @param {Object} params
 * @param {FactorId} params.method
 * @param {UserType | ""} params.userType
 * @returns {boolean}
 */
export const determineIfMFAMethodIsMandatory = ({ method, userType }) => {
  // Patients have flexible MFA - neither method is individually mandatory
  if (userType === USER_TYPES.PATIENT) {
    return false;
  }

  switch (method) {
    case MFA_FACTOR_IDS.TOTP:
      return isTOTPMFAMandatory({ userType });
    case MFA_FACTOR_IDS.PHONE:
      return isSMSMFAMandatory();
    default:
      return false;
  }
};
